// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"24bbf043","416":"aad96635","444":"b7fe8a2b","538":"7502cfce","545":"363a01e3","566":"9cc1f293","614":"084c75c7","676":"f6d8c7c6"}[chunkId] + ".chunk.js";
};